import { useMemo } from "react";
import { useEstimateEditorStore } from "@tools";
import classnames from "classnames";

export const useVisibilityModeCellClassName = (hide=false) => {
  
  const { visibilityMode } = useEstimateEditorStore();
  // const structure = useEstimateStructure();
  
  // const { apply } = structure.visibility;
  
  return useMemo(() => (
    classnames(visibilityMode && hide && "transparent-2")
  ), [visibilityMode, hide])
}